// HeroSection.jsx
import React from 'react';
import './HeroSection.css';
import { useNavigate } from 'react-router-dom';
import heroPImage from '../assets/hero-section.png';

const HeroSection = ({ onSummonClick }) => {
  const navigate = useNavigate();

  const handleSummonClick = () => {
    if (onSummonClick) {
      onSummonClick();
    }
  };

  return (
    <section className="ocs-hero-container">
      <div className="ocs-bg-elements">
        <div className="ocs-bg-circle ocs-bg-circle-1"></div>
        <div className="ocs-bg-circle ocs-bg-circle-2"></div>
        <div className="ocs-bg-grid"></div>
      </div>

      <div className="ocs-hero-wrapper">
        <div className="ocs-hero-content">
          <h1 className="ocs-hero-title">
            Your Expert<br />
            Technician,<br />
            Just One Click<br />
            Away.
          </h1>

          <p className="ocs-hero-subtitle">
            No endless searching. No waiting on hold. Get instant access to certified IT professionals,
            electricians, and appliance experts right when you need them.
          </p>

          <div className="ocs-cta-group">
            <button className="ocs-btn-primary" onClick={handleSummonClick} type="button">
              <span className="ocs-btn-dot"></span>
              Summon Technician Now
            </button>
            <button className="ocs-btn-secondary" onClick={() => navigate('/how-it-works')} type="button">
              <span className="ocs-btn-play">▶</span>
              How It Works
            </button>
          </div>

          <div className="ocs-hero-stats">
            <div className="ocs-stat-item">
              <span className="ocs-stat-number">5 Mins</span>
            </div>
            <div className="ocs-stat-divider"></div>
            <div className="ocs-stat-item">
              <span className="ocs-stat-number">99.4%</span>
            </div>
            <div className="ocs-stat-divider"></div>
            <div className="ocs-stat-item">
              <span className="ocs-stat-number">12K+</span>
            </div>
          </div>
        </div>

        <div className="ocs-hero-visual">
          <div className="ocs-image-shell">
            <img src={heroPImage} alt="Professional Technician" className="ocs-main-image" />

            <div className="ocs-float-badge ocs-float-badge-1">
              <span className="ocs-float-icon">⚡</span>
              <span className="ocs-float-text">Quick Response</span>
            </div>

            <div className="ocs-float-badge ocs-float-badge-2">
              <span className="ocs-float-icon">🧑‍🔧</span>
              <span className="ocs-float-text">Expert Team</span>
            </div>

            <div className="ocs-rating-card">
              <div className="ocs-rating-stars">★★★★★</div>
              <p className="ocs-rating-text">"Amazing service!<br />Fixed my AC in 30 mins."</p>
              <p className="ocs-rating-author">— John D.</p>
            </div>

            <div className="ocs-status-card">
              <div className="ocs-status-indicator"></div>
              <div className="ocs-status-copy">
                <span className="ocs-status-head">Technician Status</span>
                <span className="ocs-status-line">En Route • Arriving in 4m</span>
                <span className="ocs-status-bar"><i></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;